export default "__VITE_ASSET__4d02b77d__"